import { useState, useEffect } from "react";
import Lottie from "lottie-react";

import animationData from "./animation-ai.json";
import circleAnimationData from "./animation-circle-ai.json";

const LottieLoaders = ({ pageCount = 0, loader, preview }) => {
  const [count, setCount] = useState(1);
  const [percentage, setPercentage] = useState(0);
  const [notification, setNotification] = useState("");

  useEffect(() => {
    if (loader) {
      const totalTime = 70000;
      const updateInterval = totalTime / 100;

      const interval = setInterval(() => {
        setPercentage((prev) => {
          if (prev < 100) {
            return prev + 1;
          } else {
            clearInterval(interval);
            return prev;
          }
        });
      }, updateInterval);

      return () => clearInterval(interval);
    }
  }, [loader]);

  useEffect(() => {
    if (pageCount > 0) {
      const totalTime = 100000;
      const intervalTime = totalTime / pageCount;

      const interval = setInterval(() => {
        setCount((prevCount) => {
          if (prevCount < pageCount) {
            return prevCount + 1;
          }
          clearInterval(interval);
          return prevCount;
        });
      }, intervalTime);

      return () => clearInterval(interval);
    }
  }, [pageCount]);

  useEffect(() => {
    if (pageCount > 0) {
      const timePerPage = 1;
      const total = pageCount * timePerPage >= 5 ? 5 : pageCount * timePerPage;
      const notificationMessages = [
        `Calculating your project cost now. It will take approximately ${total} minute${
          total > 1 ? "s" : ""
        }. Can't wait? Close out and we'll send the quote to the email address you’ve provided.`,
        `Estimating your project cost now. It will take approximately ${total} minute${
          total > 1 ? "s" : ""
        }. In a hurry? Close out and we'll send the quote to the email address you’ve provided.`,
        `Getting your quote ready. It will take approximately ${total} minute${
          total > 1 ? "s" : ""
        }. Pressed for time? Close out and we'll send the quote to the email address you’ve provided.`,
      ];

      const randomIndex = Math.floor(
        Math.random() * notificationMessages.length
      );
      setNotification(notificationMessages[randomIndex]);
    }
  }, [pageCount]);

  return (
    <div className="app-ai-quote-lottie">
      <div className="app-ai-quote-lottie-loader">
        <Lottie
          animationData={loader ? circleAnimationData : animationData}
          loop={true}
        />
      </div>
      <h3 className="app-ai-quote-lottie-title">
        {loader ? (
          <>{percentage}%</>
        ) : (
          <>
            {count} of {pageCount}
          </>
        )}
      </h3>
      {!preview && (
        <p className="app-ai-quote-lottie-text">
          {loader ? <>Calculating...</> : <>{notification}</>}
        </p>
      )}
    </div>
  );
};

export default LottieLoaders;
